import React from "react";
import coming_soon from "../../../assets/images/Frame.svg";
import Header from "../Header";
const ComingsoonPageComponent = () => {
  return (
    <>
      <Header title="Finance" />
      <div className="coming-soonpage-container">
        <div className="child-container">
          <div className="content-main">
            <img src={coming_soon} alt="" className="comingsoon-img" />
            <h2 className="main-title">Coming Soon</h2>
          </div>
        </div>
      </div>
    </>
  );
};

export default ComingsoonPageComponent;
